import * as React from "react";
import * as ReactDOM from "react-dom";
import check from "./translations/check";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

if (process.env.NODE_ENV === "development") {
  // Check translations
  check();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
